<template>
  <div id="listWidget" class="mb-5">
    <ul class="breadcrumb">
      <li v-if="zone" class="breadcrumb-item">{{ zone?.name }}</li>
      <li class="breadcrumb-item active">{{ pageTitle }}</li>
    </ul>
    <!-- 연결된 컨트롤러 정보 카드 -->
    <ControllerCard
      :controller="connectedController"
      controller-type="조명제어기"
      mode="setting"
      @close="connectedController._id = ''"
    />

    <!-- <hr
      class="mb-4"
      v-if="
        (settingParams && settingParams.name) || lightControllers.length > 0
      "
    /> -->

    <h6 class="mb-3" v-if="settingParams && settingParams.name">
      wifi:{{ settingParams.name }}
    </h6>

    <div class="row">
      <ControllerItem
        v-for="(item, index) in lightControllers"
        :id="`controller-setting-${item._id}`"
        :key="item._id"
        :index="index"
        :data="item"
        :show-ao-link="supportsSensorAndAoLink(item)"
        :peer-controllers="aoLinkPeerControllers"
        v-on:onDeleteClick="onReceivedDeleteClick"
        v-on:onAoLinkUpdated="onAoLinkUpdated"
        v-on:onSensorLinkUpdated="onSensorLinkUpdated"
        v-on:onSensorIgnoreOffUpdated="onSensorIgnoreOffUpdated"
        v-on:onSensorOffTimerUpdated="onSensorOffTimerUpdated"
        v-on:onAoSkipSensorOnUpdated="onAoSkipSensorOnUpdated"
        v-on:onSensorOffGuardUpdated="onSensorOffGuardUpdated"
        v-on:onSensorNightUpdated="onSensorNightUpdated"
        v-on:onSensorNightLinkUpdated="onSensorNightLinkUpdated"
      />
    </div>

    <!-- wifiConnectModal -->
    <PopDialog
      title="조명제어기 AP 연결정보 설정"
      :visible="wifiConnectModal.visible"
      :okCallback="onConnect"
      :cancelCallback="wifiConnectModal.hide"
      :okText="'연결'"
      :cancelText="'닫기'"
      :clickable="false"
    >
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="ssid 입력해주세요."
        v-model="ap_wifi.ssid"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        placeholder="password 입력해주세요."
        v-model="ap_wifi.password"
      />
    </PopDialog>

    <!-- controllerWifiSettingModal -->
    <PopDialog
      title="조명제어기 Wifi 연결정보 설정"
      :visible="controllerWifiSettingModal.visible"
      :okCallback="onSettingAndRegist"
      :cancelCallback="controllerWifiSettingModal.hide"
      :clickable="false"
    >
      시리얼 넘버 : {{ connectedController._id }}<br />
      모델 코드 : {{ connectedController.model }}<br />
      펌웨어 버전 : {{ connectedController.version }}<br />

      <hr class="mb-3" />

      <input
        type="text"
        class="form-control form-control-lg fs-15px mb-2 col"
        placeholder="ssid 입력해주세요."
        v-model="settingParams.ssid"
      />
      <input
        type="text"
        class="form-control form-control-lg fs-15px col"
        placeholder="password 입력해주세요."
        v-model="settingParams.pwd"
      />
    </PopDialog>

    <!-- addControllerModal -->
    <PopDialog
      title="조명제어기 추가"
      :visible="addControllerModal.visible"
      :okCallback="onRegist"
      :cancelCallback="addControllerModal.hide"
      :clickable="false"
    >
      시리얼 넘버 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController._id"
      />
      모델 코드 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController.model"
      />
      펌웨어 버전 :
      <input
        type="text"
        class="form-control form-control-lg fs-15px"
        v-model="connectedController.version"
      />
    </PopDialog>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
  nextTick,
  
} from 'vue';
import { useStore } from 'vuex';
import Axios, { ZoneApi, GroupApi, CtrlApi } from '@/api';

import { useRouter, useRoute ,onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import PopDialog from '@/common/components/popup/PopDialog.vue';
import useModal from '@/common/hooks/useModal';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';

import ControllerItem from './components/ControllerItem.vue';
import ControllerCard from './components/ControllerCard.vue';
import WifiItem from './components/WifiItem.vue';
import { MCApi } from '@/api/mcUrls';
import { DeviceDefault, SettingConfig } from '@/common/constants';
import { supportsSensorAndAoLink } from '@/common/utils/controllerDisplayName';
import apAxios from 'axios';
import useMobile from '@/common/hooks/useMobile';
import useMqttControl from '@/common/hooks/useMqttControl';
import { isAndroid } from 'mobile-device-detect';
import useControllerProvisioning from '@/common/hooks/useControllerProvisioning';

const mqttControl = reactive(useMqttControl());
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const route = useRoute();
const props = defineProps(['data']);
const store = useStore();
const account = computed(() => store.getters['account']);
const wifiConnectModal = reactive(useModal());
const controllerWifiSettingModal = reactive(useModal());
const addControllerModal = reactive(useModal());
const {
  requestTransferController,
  searchWifiList,
} = useMobile();
const {
  connectWifiAp: connectWifiApCommon,
  provisionOverWifiAp: provisionOverWifiApCommon,
  connectBleBySerial,
  disconnectBleSafe,
  provisionOverBle,
} = useControllerProvisioning();
const controllers = computed(() => store.getters['home/getLowVersionControllers']);
const zones = computed(() => store.getters['home/getZones']);

const pageTitle = computed(() => 
  route.path.includes('regist-controllers') 
    ? '조명제어기 등록' 
    : '조명제어기 설정'
);

const forceRoute = ref(false);

const zone = ref(undefined);
const lightControllers = ref([]);
const aoLinkPeerControllers = computed(() =>
  (lightControllers.value || []).filter((c) => supportsSensorAndAoLink(c)),
);
let connectCount = 0;

let connectTimeoutId = undefined;
let settingTimeoutId = undefined;

const ap_wifi = ref({
  ssid: DeviceDefault.AP_SSID,
  password: DeviceDefault.AP_PWD,
});

// TODO : 서버에서 관리되는 모델의 펌웨어 버전 및 다운로드 url 적용 해야함.
const settingParams = ref({
  // ssid: 'MOTIZEN_IoT',
  // pwd: 'motizen$$$',
  ssid : '',
  pwd :'',
  firmware_version: '',
  firmware_url: '',
  uuid: '',
  device_key: '',
  mqtt_url: process.env.VUE_APP_CTRL_MQTT_DOMAIN,
  mqtt_username: '',
  mqtt_password: '',
});

const connectedController = ref({
  _id: '',
  version: '',
  model: '',
});

const targetController = ref(null); // 화면 진입 시 대상 컨트롤러(존에 이미 등록된 컨트롤러)
const isBleTarget = computed(() => {
  const ctrl = targetController.value;
  // Firmware 우선 → Product fallback
  if (ctrl?.firmware?.bleSupported === true) return true;
  if (ctrl?.firmware && ctrl?.firmware?.bleSupported !== true) return false;
  if (ctrl?.product?.bleSupported === true) return true;
  return false;
});
const useBle = ref(false);
const isBleConnected = ref(false);
const connectionType = ref(null); // 'ble' | 'wifi' | null

const resolveBleSupportedFromController = (controller) => {
  // Firmware 우선 → Product fallback
  if (controller?.firmware?.bleSupported === true) return true;
  if (controller?.firmware && controller?.firmware?.bleSupported !== true) return false;
  if (controller?.product?.bleSupported === true) return true;
  return false;
};

// BLE 연결 및 디바이스 정보 조회 (공통 hook 사용)
const connectBleDeviceForController = async (targetSerial) => {
  try {
    emitter.emit('setLoadingText', 'BLE 상태 확인/스캔/연결 중...');
    const { controllerInfo } = await connectBleBySerial({
      targetSerial,
      filterPrefix: 'inshow_m',
      timeout: 5,
    });
    isBleConnected.value = true;

    // 서버에서 확장된 컨트롤러 정보(product/firmware 포함)를 조회해서 로컬 상태를 enrich
    try {
      const ctrlInfo = await Axios.get(
        CtrlApi.CTRL_INFO.replace(':id', controllerInfo._id),
      );
      if (ctrlInfo?.resultCode === '0000' && ctrlInfo?.resultData) {
        Object.assign(controllerInfo, ctrlInfo.resultData);
      }
    } catch (e) {
      console.warn('Failed to enrich controller info:', e);
    }

    useBle.value = true;
    return controllerInfo;
  } catch (e) {
    // 에러 발생 시 BLE 연결 정리
    isBleConnected.value = false;
    useBle.value = false;
    await disconnectBleSafe();
    throw e;
  }
};

onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title: pageTitle.value, isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));  
  disconnectBleSafe();
  isBleConnected.value = false;
  useBle.value = false;
  connectionType.value = null;
  // 이 화면에서 showLoading/hideLoading 짝이 어긋나면 전역 라우팅이 next(false)로 막히므로
  // 화면을 떠날 때 전역 로딩을 강제로 정리한다.
  emitter.emit('hideLoading', true);
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
onMounted(() => {
  forceRoute.value = false; // 컴포넌트 마운트 시 forceRoute 초기화
  requestZone();
  console.log('ControllerSettingPage.onMounted => zone : ', zone.value);
});

onBeforeRouteUpdate((to, from) => {
  // 같은 컴포넌트가 재사용될 때 forceRoute 초기화
  forceRoute.value = false;
  return true;
});

watch(zone, () => {
  console.log('ControllerSettingPage.watch => zone : ', zone.value);
});

const setSettingModeOff = async () =>{
  forceRoute.value = true;
  const payload = {isEditMode:false}
  const result = await Axios.patch(
    ZoneApi.UPDATE_ZONE.replace(':id', zone.value._id),
    payload,
  );

  if (result.resultCode === '0000') {
    mqttControl.onPublishZone(zone.value._id,payload)
    store.dispatch('home/fetchAllZones');
  }
  // Promise가 resolve(true)되면 라우터가 자동으로 전환하므로 router.go(-1) 제거
};

onBeforeRouteLeave((to, from) => {
  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
  // 안전장치: 페이지 이탈 시 전역 로딩 강제 정리 (App.vue의 isLoading 가드로 인한 라우팅 차단 방지)
  emitter.emit('hideLoading', true);
  return true;
});

const allStopProcess = async () => {
  clearTimeout(connectTimeoutId);
  clearTimeout(settingTimeoutId);
  emitter.off('onConnectResult');
  emitter.off('onSettingResult');
  emitter.emit('hideLoading', true);
  mobile.disConnectWifi(JSON.stringify(ap_wifi.value));
  try { await disconnectBle(); } catch (_) {}
  isBleConnected.value = false;
  useBle.value = false;
  connectionType.value = null;
  await setSettingModeOff();
};

const reConnect = () => {
  if (connectCount > 4) {
    connectCount = 0;
    return;
  }

  emitter.emit('showLoading');
  connectTimeoutId = setTimeout(() => {
    connectTimeoutId = undefined;
    emitter.emit('hideLoading');
    onConnect(connectCount >= 4, connectCount);
    connectCount++;
  }, 5000);
};

// 연결 전략 함수: BLE 우선, 실패 시 WiFi(AP) 폴백
// NOTE: 이 함수는 emitter.showLoading을 호출하므로, 어떤 경로(성공/실패/return)에서도
// 반드시 hideLoading이 호출되도록 try/finally로 보장해야 한다.
const connectControllerWithFallback = async (showAlert = false, connectCount = 0) => {
  wifiConnectModal.hide();
  emitter.emit('showLoading');

  try {
    // BLE 대상인지 확인
    if (isBleTarget.value === true && targetController.value?._id) {
      try {
        // BLE 연결 시도
        const controllerInfo = await connectBleDeviceForController(targetController.value._id);

        // BLE 연결 성공
        connectionType.value = 'ble';
        connectedController.value = controllerInfo;
        controllerWifiSettingModal.show();
        return;
      } catch (e) {
        // BLE 연결 실패 - WiFi로 폴백
        logger.log('BLE connection failed, falling back to WiFi:', e);
        const errorMsg = e.message || e.toString();

        // BLE 사용 불가능한 경우가 아닌 경우에만 자동 폴백
        if (
          !errorMsg.includes('BLE를 사용할 수 없습니다') &&
          !errorMsg.includes('BLE not available')
        ) {
          // WiFi로 자동 전환 - 간단한 메시지 표시 (선택적)
          logger.log('BLE connection failed, automatically trying WiFi...');
        } else {
          // BLE 사용 불가능한 경우 - 사용자에게 알림 후 WiFi로 전환
          logger.log('BLE not available, trying WiFi connection...');
        }
      }
    }

    // WiFi(AP) 연결 시도
    try {
      const { controllerInfo } = await connectWifiApCommon({
        ssid: ap_wifi.value.ssid,
        password: ap_wifi.value.password,
        bssid: ap_wifi.value.bssid || undefined,
      });

      // WiFi 연결 성공
      connectionType.value = 'wifi';
      connectedController.value = controllerInfo;
      controllerWifiSettingModal.show();
      return;
    } catch (e) {
      // WiFi 연결도 실패
      logger.log('WiFi connection failed:', e);
      const errorMsg = e.message || e.toString();

      if (errorMsg.includes('WiFi is not enabled')) {
        // WiFi 미활성화 에러는 이미 처리됨
        return;
      }

      if (showAlert || connectCount >= 4) {
        showPopAlert(
          '조명제어기 연결에 실패하였습니다.\n조명제어기가 셋팅모드로 되어 있는지 확인해주세요.',
        );
      } else {
        // 재연결 시도
        reConnect();
      }
      return;
    }
  } finally {
    // showLoading과 항상 쌍을 맞춰서 전역 라우팅이 막히는 현상을 방지
    emitter.emit('hideLoading');
  }
};

// 컨트롤러 연결 :
const onConnect = async (showAlert = false, connectCount) => {
  console.log("showAlert", showAlert);
  
  try {
    await connectControllerWithFallback(showAlert, connectCount);
  } catch (e) {
    logger.log('Connection failed:', e);
    emitter.emit('hideLoading');
    showPopAlert('조명제어기 연결에 실패하였습니다.');
  }
};

// 컨트롤러 설정 :
const onSetting = () => {
  return new Promise(async (resolve, reject) => {
    logger.log('BleControllerSettingPage.onSetting => wifi : ' + settingParams.value);

    try {
      if (isBleConnected.value === true) {
        emitter.emit('showLoading');
        emitter.emit('setLoadingText', 'BLE로 WiFi/MQTT 설정을 전송합니다.');

        const provisionResult = await provisionOverBle({
          wifi: {
            ssid: settingParams.value.ssid,
            password: settingParams.value.pwd,
          },
          mqtt: {
            url: settingParams.value.mqtt_url,
            username: settingParams.value.mqtt_username,
            password: settingParams.value.mqtt_password,
          },
          wifiTimeout: 15,
          mqttTimeout: 15,
        });

        logger.log('BleControllerSettingPage BLE provision result:', provisionResult);

        if (
          !provisionResult?.wifi ||
          (!provisionResult.wifi.wifi_state && !provisionResult.wifi.connected)
        ) {
          throw new Error('WiFi 연결 실패');
        }

        await disconnectBleSafe();
        isBleConnected.value = false;
        useBle.value = false;
        resolve();
        emitter.emit('hideLoading', true);
        return;
      }

      emitter.emit('setLoadingText', '조명제어기에 와이파이 정보를 설정하고 있습니다.');
      await provisionOverWifiApCommon({
        settingParams: settingParams.value,
        apWifi: ap_wifi.value,
      });

      const ownedZones = zones.value.filter(item => item.ownerId == account.value._id);
      const foundZones = ownedZones.filter(item => item.controllers.find(controller => controller._id == connectedController.value._id));
      if (foundZones.length > 0) {
        reject({
          resultCode: 2001,
          resultMessage: "현재 사용하고 있는 조명제어기입니다.\nwifi정보만 재설정 되었습니다."
        });
        emitter.emit('hideLoading', true);
        return;
      }

      resolve();
    } catch (e) {
      await disconnectBleSafe();
      isBleConnected.value = false;
      useBle.value = false;

      if (e?.message) reject(e.message);
      else reject(e);
      emitter.emit('hideLoading', true);
    }
  });
};

// 컨트롤러 등록 :
const onRegist = async () => {
  const request = () => {
    return new Promise(async (resolve, reject) => {
      setTimeout(async () => {
        try {
          // const exControllerResult = await Axios.get(CtrlApi.CTRL_INFO.replace(':id', connectedController.value._id));
          // if(exControllerResult.resultCode === '0000'){
          //   if(exControllerResult.resultData) {
          //     reject("이미 등록된 컨트롤러입니다.")
          //     return;
          //   }      
          // }

          const result = await Axios.post(
            ZoneApi.REGIST_ZONE_CTRLS.replace(':id', route.params.zoneId),
            connectedController.value,
          );

          if (result?.resultCode === "0000") {
            await requestZone();
          }
          resolve(result);
        } catch (e) {
          resolve(e);
        }
      }, SettingConfig.requestInterval);
    });
  }

  return new Promise(async (resolve, reject) => {
    try {
      let result = undefined;
      for (let i = 0; i < SettingConfig.requestCount; i++) {
        emitter.emit('setLoadingText', i === 0 ? '조명제어기 정보를 서버에 등록중입니다.' : `조명제어기 정보를 서버에 ${i + 1}번째 등록 시도하고 있습니다.`);
        result = await request();
        if (result?.resultCode === "0000") {
          resolve();
          return;
        }
        if (result?.resultCode === "1001") {
          reject(result);
          emitter.emit('hideLoading', true);
          return;
        }
      }
      
      reject(result?.resultMessage?.length > 0 ? result.resultMessage : "조명제어기 등록에 실패했습니다.");
      emitter.emit('hideLoading', true);
    } catch (e) {
      console.log(e);
      reject("조명제어기 추가 중 오류가 발생하였습니다.")
      emitter.emit('hideLoading', true);
    }
  });
};

const onSettingAndRegist = async () => {
  try {
    emitter.emit('showLoading');
    await onSetting();
    await onRegist();
    controllerWifiSettingModal.hide();
    emitter.emit('hideLoading', true);
    
    await store.dispatch('home/fetchAllZones');

    forceRoute.value = true;
    emitter.emit('showPopAlert', {
      description: '조명제어기가 등록되었습니다.\n방 설정 화면으로 이동합니다.',
      okCallback: () => router.replace(`/settings/zones/${route.params.zoneId}/groups`),
      cancelCallback: () => router.replace(`/settings/zones/${route.params.zoneId}/groups`)
    });
  } catch (e) {
    emitter.emit('hideLoading', true);

    if (e.resultCode === "1001") {
      controllerWifiSettingModal.hide();

      emitter.emit('setLoadingText', '조명제어기를 이관하고 있습니다.');
      const transferController = async () => {
        const result = await requestTransferController(
          connectedController.value,
          account.value._id,
          e.resultData._id,
          route.params.zoneId
        );

        if (result?.resultCode === "0000") {
          forceRoute.value = true;
          emitter.emit("showPopAlert", {
            description: '이관이 완료되었습니다.',
            okCallback: () => router.go(-1),
            cancelCallback: () => router.go(-1),
          });
        } else {
          emitter.emit("showPopAlert", {
            description: '이관에 실패했습니다.'
          });
        }
      }

      emitter.emit('showPopAlert', {
        title: "등록된 조명제어기",
        description: "이미 등록된 조명제어기입니다.\n이관 처리됩니다.",
        okCallback: transferController,
        cancelCallback: transferController
      });
    } else if (e.resultCode == 2001) {

      emitter.emit('showPopAlert', {
        title: "wifi 정보 재설정",
        description: e.resultMessage,
        okCallback: setSettingModeOff,
        cancelCallback: setSettingModeOff
      });
    } else {
      console.log(e);
      showPopAlert(e);
    }
  } finally {
    emitter.emit('hideLoading', true);
  }
};

const showPopAlert = (msg) => {
  emitter.emit('showPopAlert', {
    description: msg,
  });
};

const requestDeleteController = async (payload) => {
  try {
    console.log(
      'ControllerSettingPage.onReceivedDeleteClick() => payload : ' +
        JSON.stringify(payload),
    );
    const result = await Axios.delete(
      CtrlApi.DELETE_CTRL.replace(':id', payload.id),
    );
    if (result.resultCode === '0000') {
      requestZone();
      store.commit('home/deleteController', {
        zoneId: route.params.zoneId,
        controllerId: payload.id,
      });
      return;
    }

    emitter.emit('showPopAlert', {
      description: result.resultMessage,
    });
  } catch (error) {
    console.log(error)
    emitter.emit('showPopAlert', {
      description: '조명제어기 삭제에 실패했습니다.',
    });
  }
};

const scrollFocusedControllerIntoView = () => {
  const raw = route.query.controllerId;
  const focusId = Array.isArray(raw) ? raw[0] : raw;
  if (!focusId) return;
  const list = lightControllers.value || [];
  const index = list.findIndex((c) => String(c._id) === String(focusId));
  if (index < 0) return;
  const isLast = route.query.scrollEnd === '1' || index === list.length - 1;
  nextTick(() => {
    requestAnimationFrame(() => {
      const el = document.getElementById(`controller-setting-${focusId}`);
      if (!el) return;
      el.scrollIntoView({
        behavior: 'auto',
        block: isLast ? 'end' : 'start',
      });
      if (isLast && el.getBoundingClientRect().top < 0) {
        el.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    });
  });
};

const requestZone = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(
        ZoneApi.ZONE_INFO.replace(':id', route.params.zoneId),
      );
      if (result.resultCode === '0000') {
        zone.value = result.resultData;
        // zone.controllers에는 기본 컨트롤러 정보만 있으므로 /controllers로 enrich 해서
        // 버튼(BLE/WiFi) 표시에 필요한 product/firmware 정보를 확보한다.
        try {
          const controllerIds = (zone.value.controllers || [])
            .map((c) => c?._id)
            .filter(Boolean);
          if (controllerIds.length > 0) {
            const ctrlRes = await Axios.get(CtrlApi.CONTROLLERS, {
              ids: controllerIds.join(','),
            });
            if (ctrlRes?.resultCode === '0000' && Array.isArray(ctrlRes.resultData)) {
              const byId = {};
              ctrlRes.resultData.forEach((c) => {
                if (c?._id) byId[c._id] = c;
              });
              if (Array.isArray(zone.value.controllers)) {
                zone.value.controllers = zone.value.controllers.map((c) => byId[c?._id] || c);
              }
            }
          }
        } catch (e) {
          console.warn('requestZone controller enrich failed:', e);
        }

        lightControllers.value = zone.value.controllers.filter(controller => controller?._id?.split("_")?.length >= 2)
        // 이 화면은 zoneId로 진입하므로, 기본적으로 첫 번째(혹은 단일) 컨트롤러를 대상 컨트롤러로 잡는다.
        targetController.value = lightControllers.value?.length > 0 ? lightControllers.value[0] : null;
        scrollFocusedControllerIntoView();
        resolve(result);
      } else {
        // emitter.emit('showPopAlert', {
        //   description: result.resultMessage,
        // });
        reject(result.resultMessage);
      }
    } catch (error) {
      // emitter.emit('showPopAlert', {
      //   description: '영역 조회에 실패했습니다.',
      // });
      reject("영역 조회에 실패했습니다.");
    }
  });
};

const onReceivedDeleteClick = async (payload) => {
  // let deviceCount = 0;
  // zone.value.groups.forEach((item) => {
  //   deviceCount = deviceCount + item.devices.filter(d => d.controllerId == payload.id).length;
  // });

  // if (deviceCount > 0) {
  //   emitter.emit('showPopAlert', {
  //     description: '단말정보가 포함된 조명제어기는 삭제할 수 없습니다.',
  //   });
  //   return;
  // }

  emitter.emit('showPopConfirm', {
    description: '관련된 장치 등의 모든 데이터가 삭제됩니다.\n조명제어기를 삭제하시겠습니까?',
    okCallback: () => requestDeleteController(payload)
  });  
};

const onAoLinkUpdated = ({ id, aoOnLinkControllers, aoOffLinkControllers }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    ...(Array.isArray(aoOnLinkControllers) ? { aoOnLinkControllers } : {}),
    ...(Array.isArray(aoOffLinkControllers) ? { aoOffLinkControllers } : {}),
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id
        ? {
            ...c,
            ...(Array.isArray(aoOnLinkControllers) ? { aoOnLinkControllers } : {}),
            ...(Array.isArray(aoOffLinkControllers) ? { aoOffLinkControllers } : {}),
          }
        : c,
    );
  }
};

const onSensorLinkUpdated = ({ id, sensorLinkChannels }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const fallback = typeof id === 'string' && id.startsWith('M02_') ? [12] : [1];
  const channels = Array.isArray(sensorLinkChannels)
    ? sensorLinkChannels
    : fallback;
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    sensorLinkChannels: channels,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, sensorLinkChannels: channels } : c,
    );
  }
};

const onSensorIgnoreOffUpdated = ({ id, sensorIgnoreOff }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const value = !!sensorIgnoreOff;
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    sensorIgnoreOff: value,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, sensorIgnoreOff: value } : c,
    );
  }
};

const onSensorOffTimerUpdated = ({ id, sensorOffTimerSec }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const value = Math.max(0, Number(sensorOffTimerSec) || 0);
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    sensorOffTimerSec: value,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, sensorOffTimerSec: value } : c,
    );
  }
};

const onAoSkipSensorOnUpdated = ({ id, aoSkipSensorOn }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const value = !!aoSkipSensorOn;
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    aoSkipSensorOn: value,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, aoSkipSensorOn: value } : c,
    );
  }
};

const onSensorOffGuardUpdated = ({ id, sensorOffGuard }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const value = !!sensorOffGuard;
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    sensorOffGuard: value,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, sensorOffGuard: value } : c,
    );
  }
};

const clampNightBright = (n) => {
  let v = Math.round(Number(n) || 30);
  if (v < 10) v = 10;
  if (v > 100) v = 100;
  v = Math.round(v / 10) * 10;
  if (v < 10) v = 10;
  return v;
};

const normalizeNightMin = (n, fallback) => {
  const v = Number(n);
  if (!Number.isFinite(v)) return fallback;
  return ((Math.floor(v) % 1440) + 1440) % 1440;
};

const onSensorNightUpdated = ({
  id,
  sensorNightEnable,
  sensorNightStartMin,
  sensorNightEndMin,
  sensorNightBright,
}) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const patch = {
    sensorNightEnable: !!sensorNightEnable,
    sensorNightStartMin: normalizeNightMin(sensorNightStartMin, 22 * 60),
    sensorNightEndMin: normalizeNightMin(sensorNightEndMin, 6 * 60),
    sensorNightBright: clampNightBright(sensorNightBright),
  };
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    ...patch,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, ...patch } : c,
    );
  }
};

const onSensorNightLinkUpdated = ({ id, sensorNightLinkChannels }) => {
  const idx = lightControllers.value.findIndex((c) => c._id === id);
  if (idx < 0) return;
  const channels = Array.isArray(sensorNightLinkChannels)
    ? sensorNightLinkChannels
    : [];
  lightControllers.value[idx] = {
    ...lightControllers.value[idx],
    sensorNightLinkChannels: channels,
  };
  if (Array.isArray(zone.value?.controllers)) {
    zone.value.controllers = zone.value.controllers.map((c) =>
      c?._id === id ? { ...c, sensorNightLinkChannels: channels } : c,
    );
  }
};
</script>

<style scoped>
.instruction-card {
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 1.2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.instruction-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.instruction-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
}

.instruction-body {
  padding: 0.75rem 1rem;
}

.instruction-step {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.instruction-step:last-child {
  margin-bottom: 0;
}

.step-number {
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0d6efd;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.75rem;
}

.step-content {
  flex: 1;
  padding-top: 0.1rem;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #495057;
}

.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.5rem;
  color: #856404;
  font-size: 0.8rem;
}

.warning-box i {
  color: #ffc107;
  flex-shrink: 0;
  margin-top: 0.1rem;
  font-size: 0.85rem;
}

.action-button-container {
  margin-top: 0;
}

.action-button-container .btn {
  padding: 0.625rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

:deep([id^='controller-setting-']) {
  scroll-margin-top: 4.5rem;
  scroll-margin-bottom: 1rem;
}

.action-button-container .btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
</style>
